'use client';

import dynamic from 'next/dynamic';

import type { BlockNoteRichTextRendererProps } from './blocknote-rich-text-renderer';

/**
 * BlockNote is large; keep it out of parent bundles (Turbopack merged-module limit).
 * `loading` is intentionally always null: next/dynamic's `loading` fallback doesn't
 * receive the props passed to the lazy component, so it can't honor `height` or
 * `hideSkeleton` for a given instance. This initial chunk-download phase is brief
 * (and usually cached); the height/skeleton-aware loading state lives inside
 * `BlockNoteRichTextRenderer` itself, which does receive the real props once mounted.
 */
const DynamicBlockNoteRichTextRenderer = dynamic(() => import('./blocknote-rich-text-renderer'), {
  ssr: false,
  loading: () => null,
});

export const LazyBlockNoteRichTextRenderer = ({
  height,
  ...props
}: BlockNoteRichTextRendererProps) => (
  <div style={height ? { minHeight: height } : undefined}>
    <DynamicBlockNoteRichTextRenderer height={height} {...props} />
  </div>
);
